export const CREATE_CUSTOMER = 'customer/createCustomer';
export const GET_CUSTOMER_LIST = 'customer/getCustomersList';
export const GET_CUSTOMER = 'customer/getCustomer';
export const RESET_SCHDULE = 'customer/resetSchdulingData';
